export default "__VITE_ASSET__BrzAKUg9__"